import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.357 3.282a.75.75 0 0 1 .561.394l3.112 5.916a.75.75 0 0 1-.104.849L12.4 21.115a.75.75 0 0 1-1.128-.01L2.064 10.432a.75.75 0 0 1-.055-.907l3.958-5.916.057-.074a.75.75 0 0 1 .566-.259h11.663l.103.007zm-6.44 15.083 2.974-7.674H9.463zm-1.896-1.008-2.133-6.666H4.27l5.75 6.666zm4.029-.347 5.643-6.319H16.5zM4.036 9.191h3.372l-1.091-3.41zm13.044 0h3.045l-1.754-3.332zm-7.334 0h5.004L12.23 5.21zm6.126-1.034 1.311-3.382h-3.451zm-7.23-.031 2.092-3.351H7.57z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const DiamondIcon = ForwardRef;